import enUs from '../languages/en-us.json';
import es from '../languages/es.json';

const languageCache = {
    'en-us': enUs,
    'es': es,
};

const DEBUG_SEARCHING_FOR_MISSING_KEYS = false;

async function loadLanguageFile(lang) {
    if (languageCache[lang]) {
        return languageCache[lang];
    }

    try {
        const langFile = await import(`../languages/${lang}.json`);
        languageCache[lang] = langFile.default;
        return langFile.default;
    } catch (error) {
        console.log(`Failed to load language file for ${lang}`);
        return null;
    }
}

export async function translate(key, lang = 'en-us') {
    let translation = null;
    if (lang !== 'en-us') {
        const langFile = await loadLanguageFile(lang);
        translation = langFile?.[key];
    }

    if (!translation) {
        translation = enUs[key];
    }

    if (!translation) {
        console.log("Error: Key not found in language file:", key);
    }
    
    return translation || key;
}

export function translateSync(key, lang = 'en-us') {
    if (lang !== 'en-us' && languageCache[lang]) {
        const translation = languageCache[lang][key];
        if (translation) return translation;
    }

    if (!enUs[key] && DEBUG_SEARCHING_FOR_MISSING_KEYS) {
        console.log("Error: Key not found in language file:", key);
    }
    
    return enUs[key] || key;
}
